import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { MapLegendItem } from '@core/interfaces';

@Component({
  selector: 'x-map-legend',
  standalone: true,
  templateUrl: './x-map-legend.component.html',
  styleUrl: './x-map-legend.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XMapLegendComponent {
  items = input.required<ReadonlyArray<MapLegendItem>>();
}
